module.exports = __webpack_public_path__ + "static/img/institucional-marcas-2.5eefa2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/institucional-marcas-2.png
// module id = Qy6p
// module chunks = 1